import { useEffect, useState } from 'react';
import { useFirebase } from '../hooks/useFirebase';
import { getValue } from 'firebase/remote-config';

let apiKey = null;

export const useAppBootstrap = () => {
    const { ready, remoteConfig } = useFirebase();
    const [bootstrapped, setBootstrapped] = useState(false);

    useEffect(() => {
        if (!ready || !remoteConfig) return;

        try {
            const env = process.env.REACT_APP_NODE_ENV || 'development';

            apiKey = getValue(remoteConfig, `${env}_api_key`).asString();

            setBootstrapped(true);
        } catch (err) {
            //eslint-disable-next-line
            console.warn('Bootstrap failed:', err);
            setBootstrapped(true);
        }
    }, [ready, remoteConfig]);

    return { bootstrapped };
};

export const getApiKey = () => apiKey;